import { SlotGameType1_2 } from "../SlotGameType1_2";
export class LuckyFire102 extends SlotGameType1_2{}